export default {
  REPAIR: 1,
  RETURN: 2,
  RECYCLE: 3,
};
